import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    UPDATE_PUBLISHER: (publisherId, publisher) => ({ publisherId, publisher }),
    API: {
      UPDATE_PUBLISHER: apiResourceActionCreator('publisher')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.putFormData(`${API_ENDPOINT}/update-publisher/${payload.publisherId}`, authToken, payload.publisher, actions.admin.api.updatePublisher);

function* updatePublisher(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));

  const result = yield apiActionResult(actions.admin.api.updatePublisher);

  if (result.success) {
    yield put(push({ pathname: routes.adminPortal.publisher }));
  }
}

const configuration = {
  name: 'updatePublisher',
  action: actions,
  sagas: updatePublisher,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/updatePublisher.js